import { render, staticRenderFns } from "./x-search-option.vue?vue&type=template&id=20d0626b"
import script from "./x-search-option.vue?vue&type=script&lang=js"
export * from "./x-search-option.vue?vue&type=script&lang=js"
import style0 from "./x-search-option.vue?vue&type=style&index=0&id=20d0626b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports